
import { useHistory } from "react-router";
import { useEffect, useState } from "react";
import { AnimateSharedLayout } from "framer-motion";
import { faChartPie, faMapLocation } from "@fortawesome/free-solid-svg-icons";

//ASSETS
import iconTalhao from '../../../../assets/img/iconTalhao.svg';
import iconTalhaoSubArea from '../../../../assets/img/iconSubArea.svg';

//STYLES
import { ContainerDashboard } from "./style";

//APP
import { useLogic } from "../../../../context/useLogic";
import { localConfig } from "../../../../Configs/localConfig";
import { useGetEquipeCliente } from "../../../../services/Equipe/GET";
import { useGetAtividadesPorTalhao, useGetPropriedadesDoCliente } from "../../../../services/atividades/GET";
import { detalhamentos, patrimonios, prazos, progressoGeral, progressoTalhoes } from "./meta/obter_dados";

//COMPONENTS
import Carregando from "../../../../Components/CustomUi/loading";
import { Prazos } from "./components/prazos";
import { Talhoes } from "../visaoGeral copy/components/talhoes";
import { PopSelect } from "../../../../Components/CustomUi/PopSelect";
import { Patrimonios } from "./components/patrimonios";
import { Detalhamento } from "./components/detalhamento";
import { ProgressoGeral } from "./components/progressoGeral";
import { SementesPorArea } from "./components/sementesPorArea";
import { PrecisaoBiologicos } from "./components/precisaoBiologicos";
import { PrecisaoInoculantes } from "./components/precisaoInoculantes";
import { MediaUsoGeralInsumos } from "./components/MediaUsoGeralInsumos";
import { InsumosPrecisaoSolidos } from "./components/insumosPrecisao";
import { InsumosPrecisaoLiquidos } from "./components/insumosLiquidosPrecisao";
import { InsumosPrecisaoSementes } from "./components/insumosSementesPrecisao";
import { MediaPrecisaoGeralInsumos } from "./components/MediaPrecisaoGeralInsumos";

//CONST
const lista_segmentos: Array<{ nome: string, cod: number }> = [
    { nome: 'Todos', cod: null },
    { nome: 'Atividades', cod: 1 },
    { nome: 'Insumos', cod: 2 },
    { nome: 'Sementes', cod: 3 },
    { nome: 'Biológicos', cod: 4 },
    { nome: 'Inoculantes', cod: 5 },
    { nome: 'Patrimônios', cod: 6 },
];

export const VisaoGeralAtv: React.FC = () => {

    //CONST
    const { checkSafra } = useLogic();
    const history = useHistory();
    const id_safra = "/atividades/dashboard"
    useEffect(() => {
        if (!!id_safra) {
            const idDaSafra = checkSafra(id_safra)

            if (!idDaSafra) {
                history.push('/home')
            }
        }
    }, [])

    //CONST
    const { codSafra } = localConfig();

    //#region STATES
    //PROPRIEDADE
    const [nome_propriedade_selecionada, setNome_propriedade_selecionada] = useState<string>('');
    const [cod_propriedade_selecionada, setCod_propriedade_selecionada] = useState<number>(null);
    //TALHÃO
    const [lista_talhoes, setLista_talhoes] = useState<any[]>([]);
    const [nome_talhao_selecionado, setNome_talhao_selecionado] = useState<string>('');
    const [cod_talhao_selecionado, setCod_talhao_selecionado] = useState<number>(null);
    const [area_talhao_selecionado, setArea_talhao_selecionado] = useState<string>('');
    //SUBAÁREA
    const [nome_subarea_selecionada, setNome_subarea_selecionada] = useState<string>('');
    const [cod_subarea_selecionada, setCod_subarea_selecionada] = useState<number>(null);
    const [area_subarea_selecionada, setArea_subarea_selecionada] = useState<string>('');
    //SEGMENTOS
    const [nome_segmento_selecionado, setNome_segmento_selecionado] = useState<string>('Todos');


    //#region API
    const { data_equipe_cliente } = useGetEquipeCliente(); //lista equipe
    const { data_propriedades, carregando_propriedades } = useGetPropriedadesDoCliente();
    const { data_atividades, carregando_atividades } = useGetAtividadesPorTalhao(cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada, true, 600000000);

    const todas_atividades_ativas = (data_atividades ?? []).filter(i => i.delete_time === null);
    const lista_subareas = (lista_talhoes ?? []).filter(i => i?.cod_safra !== null && i.cod_talhao === cod_talhao_selecionado) ?? [];

    useEffect(() => {
        setCod_talhao_selecionado(null);
        setCod_subarea_selecionada(null);
        setNome_talhao_selecionado('');
        setNome_subarea_selecionada('');
        /**obtem a lista de talhões da propriedade selecionada */
        if ((data_propriedades ?? []).length > 0) {
            let propriedade_selecionada = (data_propriedades ?? []).filter(i => i?.cod === cod_propriedade_selecionada);
            setLista_talhoes(propriedade_selecionada?.[0]?.talhao ?? []);
        }
    }, [cod_propriedade_selecionada]);

    useEffect(() => {
        setCod_subarea_selecionada(null);
        setNome_subarea_selecionada('');
    }, [cod_talhao_selecionado]);

    return (
        <ContainerDashboard>
            <div className="Dashboard__filter__container">
                <div className="Dashboard__filter">
                    <div style={{ width: '100%', display: 'flex', gap: 15, alignItems: 'center' }}>
                        <PopSelect
                            label="Selecione a propriedade"
                            empty_placeholder="Nenhuma foi selecionada"
                            icon={faMapLocation}
                            value={nome_propriedade_selecionada}
                            onChange={setNome_propriedade_selecionada}
                            onChangeId={setCod_propriedade_selecionada}
                            items={data_propriedades ?? []}
                            descricaoItem="nome"
                            idItem="cod"
                            loading={carregando_propriedades}
                            zIndex={10}
                        />
                        <PopSelect
                            label="Selecione o talhão"
                            empty_placeholder="Nenhum foi selecionado"
                            icon={iconTalhao}
                            value={nome_talhao_selecionado}
                            onChange={setNome_talhao_selecionado}
                            onChangeId={setCod_talhao_selecionado}
                            onChangeExtra={setArea_talhao_selecionado}
                            items={(lista_talhoes ?? []).filter(i => i?.cod_safra == codSafra && i.cod_talhao === null) ?? []}
                            iconList={["kml", "coordenadas"]}
                            descricaoItem="nome"
                            idItem="cod"
                            extraItem='area'
                            disabled={cod_propriedade_selecionada === null}
                            zIndex={9}
                        />
                        <PopSelect
                            label="Subarea"
                            empty_placeholder={(cod_talhao_selecionado !== null && lista_subareas.length === 0) ? 'Não possui subareas' : "Nenhuma foi selecionada"}
                            icon={iconTalhaoSubArea}
                            value={nome_subarea_selecionada}
                            onChange={setNome_subarea_selecionada}
                            onChangeId={setCod_subarea_selecionada}
                            onChangeExtra={setArea_subarea_selecionada}
                            items={lista_subareas}
                            iconList={["kml", "coordenadas"]}
                            descricaoItem="nome"
                            idItem="cod"
                            extraItem='area'
                            disabled={cod_talhao_selecionado === null || lista_subareas.length === 0}
                            zIndex={8}
                        />

                    </div>
                </div>
                <div className="Dashboard__filter__segments">
                    <PopSelect
                        label="Filtrar por segmento"
                        empty_placeholder="Nenhum segmento foi selecionado"
                        icon={faChartPie}
                        value={nome_segmento_selecionado}
                        onChange={setNome_segmento_selecionado}
                        items={lista_segmentos ?? []}
                        descricaoItem="nome"
                        idItem="cod"
                        zIndex={10}
                    />
                </div>
            </div>

            <div className="ContainerDashboard__content">

                {(carregando_atividades || carregando_propriedades)
                    ?
                    <Carregando
                        animation
                        legenda="Analisando dados das atividades..."
                        justifyContent="center"
                        height={400}
                    />
                    :
                    <AnimateSharedLayout>
                        <ProgressoGeral
                            dados_progresso={progressoGeral(todas_atividades_ativas, data_propriedades, cod_propriedade_selecionada, cod_talhao_selecionado) ?? [0, 0, 100]}
                            segmento={nome_segmento_selecionado}
                        />

                        <Prazos
                            dados_prazo={prazos(todas_atividades_ativas)?.porcentagens}
                            qtd_prazos={prazos(todas_atividades_ativas)?.quantidades}
                            segmento={nome_segmento_selecionado}
                        />

                        <MediaUsoGeralInsumos
                            todas_atividades_ativas={todas_atividades_ativas}
                            segmento={nome_segmento_selecionado}
                        />

                        <MediaPrecisaoGeralInsumos
                            todas_atividades_ativas={todas_atividades_ativas}
                            segmento={nome_segmento_selecionado}
                        />

                        <SementesPorArea
                            todas_atividades_ativas={todas_atividades_ativas}
                            data_propriedades={data_propriedades}
                            segmento={nome_segmento_selecionado}
                        />

                        <Detalhamento
                            dados_detalhamento={detalhamentos(todas_atividades_ativas, data_propriedades, cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada) ?? null}
                            todas_atividades_ativas={todas_atividades_ativas}
                            data_equipe_cliente={data_equipe_cliente}
                            data_propriedades={data_propriedades}
                            cod_propriedade_selecionada={cod_propriedade_selecionada}
                            cod_talhao_selecionado={cod_talhao_selecionado}
                            segmento={nome_segmento_selecionado}
                            cod_subarea_selecionada={cod_subarea_selecionada}
                        />

                        <InsumosPrecisaoSolidos
                            todas_atividades_ativas={todas_atividades_ativas}
                            segmento={nome_segmento_selecionado}
                            data_propriedades={data_propriedades}
                            data_equipe_cliente={data_equipe_cliente}
                        />

                        <InsumosPrecisaoLiquidos
                            todas_atividades_ativas={todas_atividades_ativas}
                            segmento={nome_segmento_selecionado}
                            data_propriedades={data_propriedades}
                            data_equipe_cliente={data_equipe_cliente}
                        />

                        <InsumosPrecisaoSementes
                            todas_atividades_ativas={todas_atividades_ativas}
                            segmento={nome_segmento_selecionado}
                            data_propriedades={data_propriedades}
                            data_equipe_cliente={data_equipe_cliente}
                        />

                        <PrecisaoInoculantes
                            todas_atividades_ativas={todas_atividades_ativas}
                            segmento={nome_segmento_selecionado}
                            data_propriedades={data_propriedades}
                            data_equipe_cliente={data_equipe_cliente}
                        />

                        <PrecisaoBiologicos
                            todas_atividades_ativas={todas_atividades_ativas}
                            segmento={nome_segmento_selecionado}
                            data_propriedades={data_propriedades}
                            data_equipe_cliente={data_equipe_cliente}
                        />

                        <Talhoes
                            title={cod_propriedade_selecionada ? 'Talhões' : 'Propriedades'}
                            placeholder={cod_propriedade_selecionada ? 'Buscar talhão' : 'Buscar propriedade'}
                            dados_talhoes={progressoTalhoes(todas_atividades_ativas, data_propriedades, cod_propriedade_selecionada, cod_talhao_selecionado)}
                            data_atividades={todas_atividades_ativas}
                            cod_propriedade={cod_propriedade_selecionada}
                            data_propriedades={data_propriedades}
                            cod_talhao={cod_talhao_selecionado}
                            data_equipe_cliente={data_equipe_cliente}
                            segmento={nome_segmento_selecionado}
                        />

                        <Patrimonios
                            dados_patrimonios={patrimonios(todas_atividades_ativas)}
                            data_atividades={todas_atividades_ativas}
                            data_propriedades={data_propriedades}
                            segmento={nome_segmento_selecionado}
                        />

                    </AnimateSharedLayout>
                }
            </div>
        </ContainerDashboard>
    )
}